import React from 'react';
import styles from './UploadClipModal.module.scss';
import Modal from '../../../../components/Modal';

const UploadClipModal = ({ open, onClose, children }) => {
    return (
        <Modal open={open} onClose={onClose} className={styles.wrapper}>
            {children}
        </Modal>
    );
}

export default UploadClipModal;